module.exports = ".count-post {\n  text-align: center;\n  margin-top: 15px; }\n\nfuse-widget {\n  width: unset; }\n"